import { PERIOD_FIELD } from '#stores/utils/filterMapping/constants/filterMapping.constant';

/**
 * Translation keys of the messages a field can raise. They are rendered through `t()` by
 * DynamicFormField.
 */
export const INVALID_DATE_FORMAT_MESSAGE = 'filters.form.error.invalidDateFormat';
export const REQUIRED_MESSAGE = 'filters.form.error.required';
export const SELECTION_REQUIRED_MESSAGE = 'filters.form.error.selectionRequired';
export const RESTRICTED_VALUE_MESSAGE = 'filters.form.error.restrictedValue';

/**
 * Fields whose missing value deserves a dedicated wording rather than the generic required
 * message. The analysis period is emptied every time the granularity changes, so the user needs to be told
 * precisely what is expected from them.
 */
export const REQUIRED_MESSAGE_BY_FIELD: Record<string, string> = {
  [PERIOD_FIELD]: 'filters.form.error.periodRequired'
};
